$(document).ready(function () {
  function convertToRoman(num) {   
    let numerals = {
       M: 1000,
       CM: 900,
       D: 500,
       CD: 400,
       C: 100,
       XC: 90,
       L: 50,
       XL: 40,
       X: 10,
       IX: 9,
       V: 5,
       IV: 4,
       I: 1,
     };
    let newNumeral = "";
    let numCopy = num;
    for (let i in numerals) { 
     for (let j= 0; j <= num; j++ ){
       if(numCopy >= numerals[i]) {
         newNumeral += i;
         numCopy -= numerals[i];
       }  
     }
    }
    return newNumeral;
  }
  if($('.explore_feature li').length > 0){
    $('.explore_feature li').each(function( index ) {
      var dataIndex = $(this).attr('data-index');
      $(this).find('span').text(convertToRoman(dataIndex))
    });
  }
  if($('.rommon_num li').length > 0){
    $('.rommon_num li').each(function( index ) {
      var dataIndex = $(this).attr('data-index');
      $(this).find('span').text(convertToRoman(dataIndex)+'.')
    });
  }
  if($('.rommon_num_icon_list li').length > 0){
    $('.rommon_num_icon_list li').each(function( index ) {
      var dataIndex = $(this).attr('data-index');
      $(this).find('span').text(convertToRoman(dataIndex)+'.')
    });
  }
  if($('.rommon_num_icon_txt li').length > 0){
    $('.rommon_num_icon_txt li').each(function( index ) {
      var dataIndex = $(this).attr('data-index');
      $(this).find('.shell_pt_number').text(convertToRoman(dataIndex)+'.')
    });
  }
  if($('a.data-link').length > 0){
    $('a.data-link').hover(function(){
      var hoverImage = $(this).attr('data-image');    
      $('.sus_left_img img').attr('src', hoverImage);
    }, function(){
      var mainImage = $('.sus_left_img').attr('data-src');    
      $('.sus_left_img img').attr('src', mainImage);
    })
  }
  if($('.sus_title_wrap .tab_scroll li').length > 0){
    $('.sus_title_wrap .tab_scroll li').each(function( index ) {
      var dataIndex = $(this).attr('data-index');
      $(this).find('span').text(convertToRoman(dataIndex)+'.')
    });
  }    
  $('body').on("click", ".sus_title_wrap .tab_scroll .js-anchor-link" , function(e){
    e.preventDefault();
    console.log('innn');
    $('.sus_title_wrap .tab_to_scroll ul li ').removeClass('active');
    var index = $(this).attr('data-img-index');
    $('.sus_title_wrap .tab_to_scroll ul li a[data-img-index="' + index + '"]').parent().addClass('active');    
  });
  
  function tabSroll() {
    if ($('.on_tab_scroll').length > 0) {
      var windowpos = $(window).scrollTop() + $('.header').outerHeight();
      var main_top = $('.on_tab_scroll').offset().top;
      var announcement = 0;
      if($('.announcement_bar').length > 0){
        announcement = $('.announcement_bar').outerHeight();
      }
      var main_slider_height = $('.on_tab_scroll').outerHeight()+$('.header').outerHeight()+announcement;
      
      
      // console.log(main_slider_height+' ---'+' - '+ main_top + ' - ' +windowpos);
      // console.log(windowpos+' >= '+main_top+' && '+windowpos+' <= '+main_slider_height);
      if (windowpos >= main_top && windowpos <= main_slider_height) {
        $('.on_tab_scroll .scroll_item').each(function () {
          if($(window).width() < 850 && $('.check_sidebar_header').length > 0 ){
            var stop = $(this).offset().top - 100 ;
          }else{
            var stop = $(this).offset().top ;
          }
          var hei = $(this).offset().top + $(this).outerHeight();
          // console.log('!!! '+ windowpos +'>='+$(this).offset().top+' <= '+hei);
          if (windowpos >= stop && windowpos <= hei) {
            $('.tab_to_scroll ul li ').removeClass('active');
            var index = $(this).attr('data-img-index');
            $('.tab_to_scroll ul li a[data-img-index="' + index + '"]').parent().addClass('active');
          } else {
            $(this).removeClass('active');
          }
        });
      } else {
        // $('.tab_to_scroll ul li').removeClass('active');
        // var index = $('.on_tab_scroll .scroll_item:eq(0)').attr('data-img-index');
        // $('.tab_to_scroll ul li a[data-img-index="' + index + '"]').parent().addClass('active');
      }
    }
  }
  setTimeout(function() {
    tabSroll();
  }, 1000)
  function check_header() {
    var wintop = $(window).scrollTop();
    var announcement = 0;
    if($('.announcement_bar').length > 0){
      announcement = $('.announcement_bar').outerHeight();
    }
    if(wintop >= announcement && $(window).width() > 767){
      if($('.announcement_bar').length > 0){
        $('.header .hd_desk_main').css('top',$('.header').outerHeight());
      }
      if($('.check_sidebar_header').length > 0){
        $('.check_sidebar_header').css('top',$('.header').outerHeight());
      }
      if($('.filter_drawer').length > 0 && $(window).width() < 768){
        $('.filter_drawer').css('top',($('.header').outerHeight()+$('.coll_filter').outerHeight()));
      }else{
        $('.filter_drawer').css('top',$('.coll_filter').outerHeight());
      }
      if($('section.coll_filter').length > 0){
        $('section.coll_filter').css('top',$('.header').outerHeight());
      }
    }else{
      var top = $('.header').outerHeight();
      if($('.announcement_bar').length > 0){
        top+=$('.announcement_bar').outerHeight();
        $('.header .hd_desk_main').css('top',top);
      }else{
        $('.header, .header-section').css('top',0);
        $('.header .hd_desk_main').css('top',top);
      }
      if($('.check_sidebar_header').length > 0){
        $('.check_sidebar_header').css('top',top);
      }
      if($('.filter_drawer').length > 0 && $(window).width() < 768){
        $('.filter_drawer').css('top',(top+$('.coll_filter').outerHeight()));
      }else{
        $('.filter_drawer').css('top',$('.coll_filter').outerHeight());
      }
      if($('section.coll_filter').length > 0){
        $('section.coll_filter').css('top',top);
      }
    }
  }
  
  check_header();
  $(window).scroll(function () {
    tabSroll();
    check_header();
  });

  if ($(window).width() < 768) {
    $('body').on('click', '.product_card .pro_img a, .product_card .pro_title a', function(e) {    
      if (!$(this).parents('.product_card').hasClass('clicked')) {
        e.preventDefault();
        $(this).parents('.product_card').addClass('clicked');
      } else {
        window.location.href = $(this).attr('href');
      }
    });
  }

    new Swiper('.announce_slider', {
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
      autoplay: {
          delay: 3000,
      }
    });

    $('body').on('click','.acnav__label, .main_parent_nav_label,.main_parent_nav_label a ',function (e) {
      if($(window).width() < 768){
      e.preventDefault();
      }
        var label = $(this);
        var parent = label.parent('.has-children');
        // var list = label.siblings('.acnav__list');
        if (parent.hasClass('is-open')) {
            parent.removeClass('is-open');
        }
        else {
            parent.addClass('is-open');
        }
    });

    $('.mob_back_inner').click(function () {
        $(this).closest('.mg_left_menu').find('.has-children').removeClass('is-open');
    });

    $('.mob_back_arrow').click(function () {
        $(this).closest('.hd_menu').find('.has-children').removeClass('is-open');
    });

    function headerspace() {
      var announcement = 0;
      if($('.announcement_bar').length > 0){
        announcement = $('.announcement_bar').outerHeight();
      }
      var headerHeight = $(window).height() - $('.header').outerHeight() - announcement;
      $('.hero_section').css("height", headerHeight)
    }
    function mobheaderspace() {
      var announcement = 0;
      if($('.announcement_bar').length > 0){
        announcement = $('.announcement_bar').outerHeight();
      }
      var mobheaderHeight = $('.header').outerHeight() + announcement;
      $('.hd_desk_main').css("top", mobheaderHeight)
    }
    function susheight() {
        var susimght = $('.sus_left').outerHeight();
        $('.sus_main_title').css("height", susimght);
    }
    function susImg() {
      var announcement = 0;
      if($('.announcement_bar').length > 0){
        announcement = $('.announcement_bar').outerHeight();
      }
      var susimgIn = $(window).height() - $('.header').outerHeight() - announcement;
      $('.sus_left').css("height", susimgIn);
    }
    headerspace();
    mobheaderspace();
    susImg();
    setTimeout(function() {
    susheight();
    }, 1000)
    $(window).on('resize orientationchange', function () {
        headerspace();
        mobheaderspace();
        susheight();
        susImg();
        //footerTop();
    });

  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    var announcement = 0;
    if($('.announcement_bar').length > 0){
      announcement = $('.announcement_bar').outerHeight();
    }
    if (scroll >= announcement) {
        var susimgIn = $(window).height() - $('.header').outerHeight();
        $('.sus_left').css("height", susimgIn);
    }else {
        var susimgIn = $(window).height() - $('.header').outerHeight() - announcement;
        $('.sus_left').css("height", susimgIn);
    }
  });

    function proSlider() {
      var swiper = new Swiper(".current:not(.related-article-tabs) .feature_pro_slider", {
          slidesPerView: 2,
          spaceBetween: 16,
          draggable: true,
          freeMode: true,
          followFinger: true,
          mousewheelControl: true,
          behavior: 'smooth',
          navigation: {
              nextEl: ".fav_arrow_next",
              prevEl: ".fav_arrow_prev",
          },
          pagination: {
              el: ".swiper-pagination",
              type: "fraction",
          },
          navigation: {
              nextEl: ".feature_next_arrow",
              prevEl: ".feature_prev_arrow",
          },
          scrollbar: {
              el: ".swiper-scrollbar",
              draggable: true,
          },
          breakpoints: {
              1024: {
                  slidesPerView: 3.68,
                  spaceBetween: 16,
              },
              767: {
                  slidesPerView: 2,
                  spaceBetween: 16,
              }
          }
      });
    }
    proSlider();

    function relatedArticleSlider() {
      var swiper = new Swiper(".related-article-tabs .feature_pro_slider", {
          slidesPerView: 2,
          spaceBetween: 16,
          draggable: true,
          freeMode: true,
          followFinger: true,
          mousewheelControl: true,
          behavior: 'smooth',
          pagination: {
              el: ".swiper-pagination-related",
              type: "fraction",
          },
          navigation: {
              nextEl: ".rart-feature_next_arrow",
              prevEl: ".rart-feature_prev_arrow",
          },
          scrollbar: {
              el: ".swiper-scrollbar-related",
              draggable: true,
          },
          breakpoints: {
              1024: {
                  slidesPerView: 3.68,
                  spaceBetween: 16,
              },
              767: {
                  slidesPerView: 2,
                  spaceBetween: 16,
              }
          }
      });
    }
    relatedArticleSlider();
    
    var swiper = new Swiper(".content_slider.content_slider_more", {
        slidesPerView: 1,
      	effect: 'fade',
        draggable: true,
        speed: 1000,
        pagination: {
          el: ".swiper-pagination-bullets",
          clickable: true,
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        fadeEffect: {
          crossFade: true
        }
    });
    $('body').on('click','.tab_link',function (e) {
        e.preventDefault()
        var tab_id = $(this).attr('data-tab');
        $('.tab_link').removeClass('current');
        $('.tab_view').removeClass('current');
        $(this).addClass('current');
        $("#" + tab_id).addClass('current');
        proSlider();
        if($(this).hasClass('recommendations')){
          setTimeout(function(){
            $("#" + tab_id).find('.product_card').each(function(i,v){
              // console.log('!!!');console.log(v);
              jQuery.get('/products/'+$(v).attr('data-handle')+'?view=color-swatch', function(pro){
                $(v).find('[data-swatch-color]').html(pro);
                setTimeout(function(){
                  $(v).find('[data-swatch-color]').addClass('pdp_tag_color-enabled');
                },500);
              }).fail(function(jqXHR, textStatus, errorThrown) {
                console.log('getJSON request failed! ' + textStatus);
              }).done(function(){
                $this.removeClass('recommendations');
              });
            });  
          },1000);
        }
    });


    $('body').on('click','ul.tabs li',function () {
        var tab_id = $(this).attr('data-tab');
        $(this).closest('.has_parent').find('ul.tabs li').removeClass('current');
        $(this).closest('.has_parent').find('.tab_content').removeClass('current');
        $(this).addClass('current');
        $("#" + tab_id).addClass('current');
    });

    $('body').on('click','ul.sub-tabs li',function () {
		var tab_id = $(this).attr('data-tab');
		$(this).closest('.has_parent').find('ul.sub-tabs li').removeClass('current');
		$(this).closest('.has_parent').find('.tab_sub_content').removeClass('current');
		$(this).addClass('current');
		$("#" + tab_id).addClass('current');
	});

     $('body').on('mouseenter','.shell_pt_right ul li',function () {
        var tab_id = $(this).attr('data-tab');
        $(this).closest('.has_parent').find('.shell_pt_right ul li').removeClass('current').addClass('hovered');
        $(this).closest('.has_parent').find('.shell_point_img').removeClass('current');
        $(this).addClass('current');
        $("#" + tab_id).addClass('current').removeClass('hovered');
    });
 
    $('body').on('mouseenter','.shell_point_img',function () {
        var tab_id = $(this).attr('id');
        $(this).closest('.has_parent').find('.shell_pt_right ul li').removeClass('current').addClass('hovered');
        $(this).closest('.has_parent').find('.shell_point_img').removeClass('current');
        $(this).addClass('current');
        $('[data-tab="'+tab_id+'"]').addClass('current').removeClass('hovered');
    });
  
    $('body').on('mouseleave','.shell_pt_right ul li, .shell_point_img',function () {
      $('.shell_pt_right ul li').removeClass('current, hovered');
      $('.shell_point_img').removeClass('current');
    });


    $('.search_bar a').click(function () {
      $('.menu_search').slideToggle();
      if($(this).hasClass('close_icon')||$('.menu_search').hasClass('active')){
        $(".header_right #Search").blur();
        $(".mob_search #Search").blur();
        $('.menu_search').removeClass('active');
      }else{
        $('.menu_search').addClass('active');
        $(".header_right #Search").focus();
        $(".mob_search #Search").focus();
      }
    });
  

    $('.nsw_close, .nsl_overlay').click(function (e) {
        e.preventDefault()
        $('.newslatter').removeClass('active_nsl');
    });


    $('.mob_hamburger').click(function () {
        $(this).toggleClass('open');
        if($('.size_pop_wrap').length > 0){
          $('.size_pop_wrap, body').removeClass('active');
        }
        $('.hd_desk_main, body').toggleClass('active_menu');
        check_header();
    });


    // $('.animation-line').infiniteslide({
    //     speed: 50,
    //     pauseonhover: false,
    //     clone: 5,
    // });

    $('body').on('click','.ft_btn',function (e) {
        e.preventDefault()
        $(".ft_btn,body").removeClass("active_filter");
        $("body").removeClass("no-scroll");
        $(".filter_drawer").slideUp();
        if (!$(this).next().is(":visible")) {
            $(this).next().slideDown();
            $(this).addClass("active_filter");
          $('body').addClass("no-scroll");
        }
    })
    $('body').on('click','.cm_mesure_title',function (e) {
        e.preventDefault()
        $(".cm_mesure_title").removeClass("active");
        $(".cm_mesure_content").slideUp();
        if (!$(this).next().is(":visible")) {
            $(this).next().slideDown();
            $(this).addClass("active");
        }
    })
    if ($(window).width() < 768) {
        $('body').on('click','.filter_heading',function () {
            $(".filter_heading").removeClass("active_ft_menu");
            $(".filter-box .filter_content").slideUp();
            if (!$(this).next().is(":visible")) {
                $(this).next().slideDown();
                $(this).addClass("active_ft_menu");
            }
        });
    }
    $('body').on('click','.faq_title',function (e) {
        e.preventDefault()
        $(".faq_title").removeClass("active");
        $(".faq_content").slideUp();
        if (!$(this).next().is(":visible")) {
            $(this).next().slideDown();
            $(this).addClass("active");
        }
    });

 if($('.handle-page-customer-care').length > 0){
  $('body').on('click','.menu_bottom_info li a',function (e) {
    e.preventDefault();
    var current_url = window.location.href;
    var target = $(this).attr('href');
    var test = target.split("#");
    var heHeader = $('.header').outerHeight()-1;
    var announcement = 0;
    if($('.announcement_bar').length > 0){
      announcement = $('.announcement_bar').outerHeight();
    }
    var scrollTo = $('#'+test[1]).offset().top - heHeader - announcement -$('.check_sidebar_header').outerHeight();
     $('.mob_hamburger').trigger('click');     
     $('body, html').animate({ scrollTop: scrollTo + 'px' }, 200);
  });
 }

    $('body').on('click','.js-anchor-link',function (e) {
      e.preventDefault();
      var target = $($(this).attr('href'));
      var heHeader = $('.header').outerHeight()-1;
      var announcement = 0;
      if($('.announcement_bar').length > 0){
        announcement = $('.announcement_bar').outerHeight();  
      }
    
        if (target.length) {
          if($(window).width() < 850){
            var scrollTo = target.offset().top - heHeader - announcement -$('.check_sidebar_header').outerHeight();
          }else{
            var scrollTo = target.offset().top - heHeader;
          }
          $('body, html').animate({ scrollTop: scrollTo + 'px' }, 200);
        }   
    });



    'use strict';
    const breakpoint = window.matchMedia('(min-width:768px)');
    let mySwiper;
    const breakpointChecker = function () {
        if (breakpoint.matches === true) {
            if (mySwiper !== undefined) mySwiper.destroy(true, true);
            return;
        } else if (breakpoint.matches === false) {
            return enableSwiper();

        }

    };

    const enableSwiper = function () {

        mySwiper = new Swiper('.pdp_main_media', {
            loop: true,
            slidesPerView: 1,
            grabCursor: true,
            pagination: {
              el: ".pdp-swiper-pagination",
              clickable: true
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            paginationClickable: true,
        });

    };

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();


    var add_text = window.variantStrings.addToCart;
    var sold_text = window.variantStrings.soldOut;
    var mf = window.variantStrings.mf;
    function addBtnText(disable, text, btnClass) {
      if (!btnClass) {
        return;
      }
      if (disable) {
        btnClass.prop('disabled', true);
        btnClass.hide();
        if (text) {
          btnClass.html(text);
        }
      } else {
        btnClass.prop('disabled', false);
        btnClass.show();
        btnClass.html(add_text);
      }
    }
    function varaintSelect(form, check, _this) {
      var section = form.find('.varaint-selector').data('section');
      var url = form.find('.varaint-selector').data('url');
      var getVariantData = JSON.parse(form.find('[type="application/json"]').text());
      var fieldsets = form.find('.product-form__input').toArray();
      var addButton = form.find('[name="add"]');
      var options = [];
  
      $.each(fieldsets, function (i, v){ 
        var value = $(v).find("input[type='radio']:checked").val();
        options.push(value);
      });
      
      var currentVariant;
  
      $.each(getVariantData, function (i, variant){
        var lll = 0;
        $.each(variant.options, function (index, option){ 
          if(options[index] !== option){
            lll = 1;
          }
        });
        if(lll == 0){
          currentVariant = variant;
        }
      });
  
      addBtnText(true, '', addButton)
  
      if (!currentVariant) {
        addBtnText(true, '', addButton);
        if (!addButton) {
          return;
        }
        addButton.html('Unavailable');
      } else {
              
        if (!currentVariant) {
          return;
        }

        if(!form.hasClass('product_card')){
          // console.log('%%%%@'+ form.attr('class'));
          window.history.replaceState({ }, '', url+'?variant='+currentVariant.id);  
        }
  
        const input = form.find('input[name="id"]');
        input.val(currentVariant.id).trigger('change');
        $('#notify_button').attr('data-variant-id', currentVariant.id)
        $('.add_btn.checkout').attr('href', '/cart/'+currentVariant.id+':1')
        if (currentVariant.available) {
          $('.notify_wrapper').hide();
          $('.add_to_bag .checkout').removeClass('pro_checkout');
          $('.add_btn.checkout').removeClass('disabled').show();
        } else {
            $('.notify_wrapper').show();
          $('.add_to_bag .checkout').addClass('pro_checkout');
          $('.add_btn.checkout').addClass('disabled').hide();
        }
        
        addBtnText(!currentVariant.available, sold_text, addButton);
  
        $.get(url+'?variant='+currentVariant.id+'&section_id='+section, function(data){
          
          const html = new DOMParser().parseFromString(data, 'text/html')
          const destination = document.getElementById(`price-${section}`);
          const source = html.getElementById(`price-${section}`);
          if (source && destination) destination.innerHTML = source.innerHTML;
  
          const price = document.getElementById(`price-${section}`);
  
          if (price) price.classList.remove('visibility-hidden');
        });

        if(form.hasClass('product_card') && check){
        var id = currentVariant.id;
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {id:id,quantity:1},
          dataType: 'json',
          error: function(jqXHR, textStatus, errorThrown){
            var response = $.parseJSON(jqXHR.responseText);
            alert(response.description);
            form.find('.size_variant input:checked').prop('checked',false);
          }
        }).done(function( data ) {
          $.get("/cart?view=minicart", function(data) {
            $('.mini_cart_wrap').html($(data).find('.mini_cart_wrap').html());
          });
          $.getJSON("/cart", function(data) {
            $('.cart_item_count').text('('+data.item_count+')');
          });
          
          $('.mini_cart_drower, body').addClass('active_cart');
          form.find('.size_variant input:checked').prop('checked',false);
        });
      }
        
      }
      
    }

    if($('[data-pro-form-main]').length > 0 ){
      $(window).on("load", function() {
        $('[data-pro-form-main]').each(function(){
          var form = $(this);
          var check = false;
          varaintSelect(form,check);
        });
      });
    }
  
    $('body').on('click','.variant-radios input', function() {
      var form = $(this).parents('[data-pro-form-main]');
      var check = true;
      varaintSelect(form,check);
    });
  
    $('body').on('click','.mini_cart',function () {
      $('.mini_cart_drower, body').addClass('active_cart');
      if($('.size_pop_wrap').length > 0){
        $('.size_pop_wrap, body').removeClass('active');
      }
    });

    $('body').on('click','.mini_cart_over, .cart_close',function () {
      $('.mini_cart_drower, body').removeClass('active_cart');
    });

  $('body').on('click', '[data-add-to-cart]', function(e) {
    e.preventDefault();
    var formData = $(this).parents('form').serialize();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      }
    }).done(function( data ) {
      $.get("/cart?view=minicart", function(data) {
        $('.mini_cart_wrap').html($(data).find('.mini_cart_wrap').html());
      });
      $.getJSON("/cart", function(data) {
        $('.cart_item_count').text('('+data.item_count+')');
      });
      
      $('.mini_cart_drower, body').addClass('active_cart');
    });
  });

  $('body').on('click','.mini_cart_drower .qty_wrap .qty_btn ',function(e){
    e.preventDefault();
    var $this =$(this);
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('qty-plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    input.val(ip);
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      }
    }).done(function( data ) {
      $.get( "/cart?view=minicart", function( data ) {
        $('.mini_cart_wrap').html($(data).find('.mini_cart_wrap').html());
      });
      $('.cart_item_count').text('('+data.item_count+')');
    });
  });
  $('body').on('click', '.cart_iten_remove', function(e) {
      e.preventDefault();
      var id = $(this).attr('data-id');
      jQuery.ajax({
        type : 'POST',
        url : '/cart/change.js',
        dataType : 'json',
        data : {
          id: id, 
          quantity: 0
        },
        success : function(data){
          $.get( "/cart?view=minicart", function( data ) {
            $('.mini_cart_wrap').html($(data).find('.mini_cart_wrap').html());
          });
          $('.cart_item_count').text('('+data.item_count+')');
        },
        error: function(){
          console.log('error when removing product from the cart');
        }
      });
    });
  $('body').on('click','.main_cart .qty-box .qty-item',function(e){
  e.preventDefault();
  var input = $(this).parent().find('input');
  var ip = parseInt(input.val());
  if($(this).hasClass('plus')) {
    ip = ip + 1;
  } else {
    ip = ip - 1; 
  }
  if(ip == 0){
    return false;
  }
  input.val(ip);
  var id = parseInt(input.attr('data-id'));
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: 'updates['+id+']='+ip,
    dataType: 'json',
    error: function(jqXHR, textStatus, errorThrown){
      var response = $.parseJSON(jqXHR.responseText);
      alert(response.description);
    },
    success: function(cart){
      $('.cart_item_count').text('('+cart.item_count+')');
    $.get( "/cart?view=alternate", function( data ) {
      $('.main_cart').html($(data).find('.main_cart').html());
    });
     
    }
  });
});

    $('body').on('click','.product_card .colour_variant label',function(){
      var handle = $(this).parent().find('input').attr('data-handle');
      var current_ele = $(this).closest('.product_card');
      // $.get( '/products/'+ handle+'?view=alternate', function( data ) {
      //   $(current_ele).html($(data).find('.product_card').html());
      // })
      $.ajax({
         url: '/products/'+ handle+'?view=alternate',
         type:'GET',
         success: function(data){
             $(current_ele).html($(data).find('.product_card').html());
         }
      });
    });

    $('body').on('click','.popup_click',function () {
      var announcement = 0;
      if($('.announcement_bar').length > 0){
        announcement = $('.announcement_bar').outerHeight();
      }
      if($(window).width() < 768){
        $('.size_pop_wrap').css('top',($('.header').outerHeight()+announcement));
        $('.size_pop_wrap .size_pop_inner').css('max-height','100%');
      }
      $('.size_pop_wrap , body').addClass('active');
    });

    $('body').on('click','.size_close, .size_pop_overlay',function () {
      $('.size_pop_wrap, body').removeClass('active');
    });

    $('body').on('click','.customer-address-form input[type="checkbox"]',function(){
      $('.customer-address-form [type="checkbox"]').prop('checked',false);
      $(this).prop('checked',true);
      $(this).closest('.customer-address-form').find('button').trigger('click');
    });

  
  
});


$(function () {
    $('.footer_common_top').infiniteslide({
        speed: 30,
        pauseonhover: false,
        clone: 5,
    });
});

$(window).on('load', function() {
  var url = window.location.href;
  if (url.indexOf('customer_posted=true') > -1) {
    var id = url.split('#')[1];
    localStorage.setItem('test', id);
  }
  var done = localStorage.getItem('test');
  if (done != '') {
    if (url.indexOf('customer_posted=true') > -1) {
      window.history.replaceState({ id: "100" }, 'collection', '#'+done);
      $('form#'+done).find('.success_message').show();
    }
  }
});


